type QueueComponent = {
  id: string;
  component: string;
  props?: string;
  inPopup?: boolean;
};

const createReactRenderQueue = () => {
  const queue: QueueComponent[] = [];
  let renderComponent: ((component: QueueComponent) => void) | null = null;
  let renderCallbacks: Array<() => void> = [];

  return {
    push: function (message: QueueComponent) {
      if (renderComponent) {
        renderComponent(message);
      } else {
        queue.push(message);
      }
    },
    start: function (callback: (component: QueueComponent) => void) {
      let component;
      while ((component = queue.shift())) {
        callback(component);
      }
      renderComponent = callback;
    },
    addRenderCallback: (callback: () => void) => {
      renderCallbacks.push(callback);
    },
    processRenderCallbacks: () => {
      renderCallbacks.forEach((callback) => callback());
      renderCallbacks = [];
    },
  };
};

export default createReactRenderQueue;
